module.exports = __webpack_public_path__ + "img/12.f37c33b.jpg";